import React, { useState, useEffect } from 'react';
import Header from './components/Header.js';
import Footer from './components/Footer.js';
import Login from './components/Login.js';
import DataEntry from './components/DataEntry.js';
import Success from './components/Success.js';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [currentPage, setCurrentPage] = useState('login');
  const [userInfo, setUserInfo] = useState(null);
  const [facilityInfo, setFacilityInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Check if user is already authenticated
    const savedAuth = sessionStorage.getItem('isAuthenticated');
    const savedUserInfo = sessionStorage.getItem('userInfo');
    const savedFacilityInfo = sessionStorage.getItem('facilityInfo');
    
    if (savedAuth === 'true' && savedUserInfo && savedFacilityInfo) {
      setIsAuthenticated(true);
      setUserInfo(JSON.parse(savedUserInfo));
      setFacilityInfo(JSON.parse(savedFacilityInfo));
      setCurrentPage('dataEntry');
    }
    
    setLoading(false);
  }, []);

  const handleLogin = (userInfo, facilityInfo) => {
    setUserInfo(userInfo);
    setFacilityInfo(facilityInfo);
    setIsAuthenticated(true);
    setCurrentPage('dataEntry');
    
    // Save to session storage
    sessionStorage.setItem('isAuthenticated', 'true');
    sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
    sessionStorage.setItem('facilityInfo', JSON.stringify(facilityInfo));
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setUserInfo(null);
    setFacilityInfo(null);
    setCurrentPage('login');
    
    // Clear session storage
    sessionStorage.removeItem('isAuthenticated');
    sessionStorage.removeItem('userInfo');
    sessionStorage.removeItem('facilityInfo');
    sessionStorage.removeItem('submissionData');
  };

  const handleHeaderNavigation = () => {
    // Navigate back to login page when header is clicked
    // This maintains the user session but returns to login view
    setCurrentPage('login');
  };

  const handleSuccess = () => {
    setCurrentPage('success');
  };

  const handleBackToDataEntry = () => {
    setCurrentPage('dataEntry');
  };

  if (loading) {
    return (
      <div className="app">
        <Header onNavigateToLogin={handleHeaderNavigation} />
        <main role="main" className="container fill-content" id="main-content">
          <div className="main-content">
            <div className="text-center">
              <h1 className="text-type-2 text-header">Loading...</h1>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  if (error) {
    return (
      <div className="app">
        <Header onNavigateToLogin={handleHeaderNavigation} />
        <main role="main" className="container fill-content" id="main-content">
          <div className="error-message" role="alert">
            <h1 className="text-type-1 text-danger">Error Loading Application</h1>
            <p className="text-type-5 text-body">{error}</p>
            <button 
              className="som-button som-button--primary"
              onClick={() => window.location.reload()}
            >
              Retry
            </button>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="app">
      <Header onNavigateToLogin={handleHeaderNavigation} />
      <main role="main" className="container fill-content" id="main-content">
        <div className="main-content">
          {currentPage === 'login' && (
            <Login onLogin={handleLogin} />
          )}
          {currentPage === 'dataEntry' && (
            <DataEntry 
              userInfo={userInfo}
              facilityInfo={facilityInfo}
              onSuccess={handleSuccess}
              onLogout={handleLogout}
            />
          )}
          {currentPage === 'success' && (
            <Success onBackToDataEntry={handleBackToDataEntry} />
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default App;